module.exports = __webpack_public_path__ + "static/media/profilepic.b5a13ad8.jpg";